import script from "./ContentCallout.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentCallout.vue?vue&type=script&setup=true&lang=js"

import "./ContentCallout.vue?vue&type=style&index=0&id=01d41c6b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d41c6b"]])

export default __exports__